import { useRef } from 'react';
import { Chart } from 'react-chartjs-2';
import { Chart as ChartJS, CategoryScale, LinearScale, BarElement, LineElement, PointElement, LineController, BarController, Title, Tooltip, Legend } from 'chart.js';
import { CURRENCY } from "../../../utils/utils.js";

ChartJS.register(CategoryScale, LinearScale, BarElement, LineElement, PointElement, LineController, BarController, Title, Tooltip, Legend);

const SalesExpensesChart = ({ sales, expenses, grossProfit, netProfit }) => {
  const chartRef = useRef();

  const data = {
    labels: ['Sales', 'Expenses', 'Gross Profit', 'Net Profit'],
    datasets: [
      {
        type: 'bar',
        label: `Amount in ${CURRENCY} (Bars)`,
        data: [sales, expenses, grossProfit, netProfit],
        backgroundColor: (context) => {
          const chart = context.chart;
          const { ctx, chartArea } = chart;
          if (!chartArea) return 'rgba(75, 192, 192, 0.6)';
          const gradient = ctx.createLinearGradient(0, chartArea.bottom, 0, chartArea.top);
          gradient.addColorStop(0, 'rgba(75, 192, 192, 0.6)');
          gradient.addColorStop(1, 'rgba(75, 192, 192, 1)');
          return gradient;
        },
        borderColor: 'rgba(75, 192, 192, 1)',
        borderWidth: 1,
      },
      {
        type: 'line',
        label: `Amount in ${CURRENCY} (Line)`,
        data: [sales, expenses, grossProfit, netProfit],
        fill: false,
        backgroundColor: 'rgba(0,0,0,0)',
        borderColor: (context) => {
          const chart = context.chart;
          const { ctx, chartArea } = chart;
          if (!chartArea) return 'rgba(255, 99, 132, 1)';
          const gradient = ctx.createLinearGradient(chartArea.left, 0, chartArea.right, 0);
          gradient.addColorStop(0, 'rgba(255, 99, 132, 1)');
          gradient.addColorStop(0.5, 'rgba(255, 206, 86, 1)');
          gradient.addColorStop(1, 'rgba(54, 162, 235, 1)');
          return gradient;
        },
        borderWidth: 2,
        pointBackgroundColor: ['rgba(255, 99, 132, 1)', 'rgba(255, 206, 86, 1)', 'rgba(54, 162, 235, 1)', 'rgba(75, 192, 192, 1)'],
        pointBorderColor: '#fff',
        pointBorderWidth: 2,
        pointRadius: 5,
      },
    ],
  };

  const options = {
    responsive: true,
    plugins: {
      legend: {
        position: 'top',
      },
      title: {
        display: true,
        text: 'Sales, Expenses, Gross Profit & Net Profit',
      },
    },
  };

  return <Chart ref={chartRef} data={data} options={options} />;
};

export default SalesExpensesChart;